"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductArtifactsTypes = void 0;
var ProductArtifactsTypes;
exports.ProductArtifactsTypes = ProductArtifactsTypes;
(function (ProductArtifactsTypes) {
  ProductArtifactsTypes["Git"] = "Scms.Git.Vsts";
  ProductArtifactsTypes["GitHubRepo"] = "GitHub/Repository";
  ProductArtifactsTypes["AreaPathVSTS"] = "AreaPath.Vsts";
  ProductArtifactsTypes["AdoBuildDefs"] = "Microsoft.AzureDevOps/BuildDefinition";
  ProductArtifactsTypes["AdoReleaseDefs"] = "Microsoft.AzureDevOps/ReleaseDefinition";
  ProductArtifactsTypes["AdoReleaseDefEnv"] = "Microsoft.AzureDevOps/ReleaseDefinitionEnvironment";
})(ProductArtifactsTypes || (exports.ProductArtifactsTypes = ProductArtifactsTypes = {}));